import React from "react";
import Button from "@material-ui/core/Button";
import Dashboard from "./pages/Dashboard";
import { Router, Route, Switch } from "react-router-dom";

import PrivateRoute from "./components/PrivateRoute";
import { useAuth0 } from "./hooks/react-auth0-spa";
import history from "./utils/history";

// import { API_URL } from "./constants/constants";
// import useCotizacionAPI from "./hooks/useCotizacionAPI";
// import Login from "./pages/Login/Login";

const Login = () => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  // console.log(loginWithRedirect, typeof loginWithRedirect);
  return (
    <>
      {isAuthenticated ? (
        <p>Logged</p>
      ) : (
        <>
          <h3>Not logged</h3>
          <Button
            onClick={() =>
              loginWithRedirect({
                mode: "signUp"
              })
            }
          >
            Login
          </Button>
        </>
      )}
    </>
  );
};

const Logout = () => {
  const { logout, isAuthenticated } = useAuth0();
  if (!isAuthenticated) {
    return (
      <>
        <h2>Usuario no autenticado</h2>
      </>
    );
  }
  logout();
  return (
    <>
      <h2>Usuario autenticado</h2>
      <p>Saliendo...</p>
    </>
  );
};
function App() {
  return (
    <Router history={history}>
      <Switch>
        <PrivateRoute path="/" component={Dashboard} exact />
        <PrivateRoute path="/dashboard" component={Dashboard} exact />

        <Route path="/login" component={Login} exact />
        <Route path="/logout" component={Logout} exact />
      </Switch>
    </Router>
  );
}

export default App;
